"use strict";
var fastpriorityqueue_ts_1 = require('fastpriorityqueue.ts');
var NavMesh_1 = require('./NavMesh');
function HeuristicCostEstimate(startNode, goalNode) {
    return NavMesh_1.Node.getDistance(startNode, goalNode);
}
var PathFinder = (function () {
    function PathFinder() {
    }
    PathFinder.prototype.findPath = function (startNode, goalNode) {
        var frontier = new fastpriorityqueue_ts_1.FastPriorityQueue();
        var explored = new Set();
        // A dictionary mapping from nodes to nodes,
        //  used to keep track of the path
        //  The node that is the key
        var pathTo = new WeakMap();
        // A dictionary mapping from nodes to floats,
        // used to keep track of the "G cost" associated with traveling to each node from startNode
        var gCost = new WeakMap();
        pathTo.set(startNode, null);
        gCost.set(startNode, 0);
        frontier.add(startNode, 0.0 + HeuristicCostEstimate(startNode, goalNode));
        while (!frontier.isEmpty()) {
            var leafNode = frontier.peek();
            if (leafNode.object === goalNode) {
                // We found the solution! Reconstruct it.
                var path = [];
                var pointer = pathTo.get(goalNode);
                while (pointer != null) {
                    path.push(pointer);
                    pointer = pathTo.get(pointer.src);
                }
                return path;
            }
            frontier.poll();
            explored.add(leafNode.object);
            for (var i = 0, len = leafNode.object.edges.length; i < len; ++i) {
                var edge = leafNode.object.edges[i];
                var connectedNode = edge.dest;
                if (!explored.has(connectedNode) && !frontier.has(connectedNode)) {
                    gCost.set(connectedNode, gCost.get(leafNode.object) + edge.length);
                    pathTo.set(connectedNode, edge);
                    frontier.add(connectedNode, gCost.get(connectedNode) + HeuristicCostEstimate(connectedNode, goalNode));
                }
            }
        }
        return null; // No path could be found
    };
    return PathFinder;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PathFinder;
//# sourceMappingURL=PathFinder.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/pathfinder/lib/PathFinder.js
 ** module id = 1158
 ** module chunks = 0
 **/